// src/store/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isLoginUser: false,
  },
  reducers: {
    loginUser: (state) => {
      state.isLoginUser = true;
    },
    logoutUser: (state) => {
      state.isLoginUser = false;
    },
  },
});

export const { loginUser, logoutUser } = authSlice.actions;

export default authSlice.reducer;
